import React from "react";
import { IVersionsWrapper } from "../interfaces";

export interface IVersionProps {
    versionsWrapper?: IVersionsWrapper;
}

const TabVersionMobile = (props?: IVersionProps) => {

    const versionsWrapper = props?.versionsWrapper;

    if(!versionsWrapper) return null;

    return (
        <div className="my-4">
            {
                versionsWrapper.versions?.length > 0 &&
                <>
                    {
                        versionsWrapper.versions.map((version, index) => {
                            return (
                                <div
                                    key={ `${ version.documentName }-${ index }` }
                                ><span dangerouslySetInnerHTML={{ __html: version.versions ?? '' }} /></div>
                            )
                        })
                    }
                </>
            }
        </div>
    )
};

export default TabVersionMobile;